import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, mergeProps as _mergeProps, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5172f7d9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contentHeader flex" }
const _hoisted_2 = { class: "contentBox" }
const _hoisted_3 = { class: "block w-full" }
const _hoisted_4 = { class: "flex mb-4" }
const _hoisted_5 = { class: "ml-auto" }
const _hoisted_6 = { class: "text-center" }

import {useSystemStore} from "@/stores/system/SystemStore";
import {BryntumGrid} from "@bryntum/grid-vue-3";
import GridInputFilter from "@/components/system/GridInputFilter.vue";
import {ErrorLocationType, PopupType, TableType} from "@/utilities/system/enums/Enums";
import {onBeforeUnmount, onMounted, reactive, ref} from "vue";
import {Menu, Store, StringHelper} from "@bryntum/grid";
import {defaultSpaceAroundTableOnPage, featureColumn} from "@/AppConfig";
import {useI18n} from "vue-i18n";
import FilterService from "@/utilities/system/services/FilterService";
import {FormService} from "@/utilities/services/entities/FormService";
import DateToStringHelper from "@/utilities/system/helpers/DateToStringHelper";
import NullOrUndefinedHelper from "@/utilities/system/helpers/NullOrUndefinedHelper";
import {FormType} from "@/utilities/enums/Enums";
import LoadingSpinner from "@/components/system/LoadingSpinner.vue";
import Error from "@/components/system/Error.vue";
import {Form} from "@/models/entities/forms/Form";




export default /*#__PURE__*/_defineComponent({
  __name: 'FormReports',
  setup(__props) {

const {t} = useI18n();
const systemStore = useSystemStore();
const formService = new FormService();

const currentWindowHeight = ref("");
const recalcGridHeight = () => {
  currentWindowHeight.value = `${window.innerHeight-defaultSpaceAroundTableOnPage}px`;
};


const selectedForms = ref([])
const pdfExportRunning = ref<boolean>(false)
const pdfLoadingRecords = reactive<Record<string, boolean>>({})
let lastOwnerId = ""


const gridStore = new Store({
  sorters: [{
    field: 'createdAt',
    ascending: false
  }]
})
const grid = ref(null)
const useGridConfig = {
  headerMenuFeature: false,
  relayStoreEvents: true,
  cellTooltipFeature: {
    hoverDelay      : 300,
    textContent     : true,
    hideOnDelegateChange: true,
  },
  enableTextSelection: false,
  selectionMode : {
    row	  : false,
    checkbox: false,
    showCheckAll : false,
    deselectFilteredOutRecords: false
  },
  columns : {
    data: [
      {
        id:'isOpen',
        field: 'isOpen',
        text: "",
        width: 30,
        minWidth: 30,
        type: "template",
        template: ({ value }:any) => {
          return value
              ? `<div class="userActivity isActive"></div>`
              : `<div class="userActivity"></div>`;
        },
      },
      {
        id:'id',
        field: 'id',
        text: t('formReports.grid.id'),
        flex: 1,
        type: "template",
        template: ({value}:any) => {
          return StringHelper.xss`${value ?? ""}`;
        }
      },
      {
        id:'ownerName',
        field: 'ownerName',
        text: t('formReports.grid.ownerName'),
        flex: 1,
        type: "template",
        template: ({record}:any) => {
          const creatorName = (record.data.creatorName ?? "").trim();
          const ownerName = (record.data.ownerName ?? "").trim();

          if(!creatorName) {
            return StringHelper.xss`${ownerName}`;
          }

          if(ownerName && ownerName !== creatorName) {
            return StringHelper.xss`${ownerName} (${creatorName})`;
          }

          return StringHelper.xss`${creatorName}`;
        }
      },
      // {
      //   id:'ownerName',
      //   field: 'ownerName',
      //   text: t('formReports.grid.ownerName'),
      //   flex: 1,
      //   type: "template",
      //   template: ({value}:any) => {
      //     return StringHelper.xss`${value ?? ""}`;
      //   }
      // },
      {
        id:'locationName',
        field: 'locationName',
        text: t('formReports.grid.locationName'),
        flex: 1,
        type: "template",
        template: ({value}:any) => {
          return StringHelper.xss`${value ?? ""}`;
        }
      },
      {
        id:'facilityName',
        field: 'facilityName',
        text: t('formReports.grid.facilityName'),
        flex: 1,
        type: "template",
        template: ({value}:any) => {
          return StringHelper.xss`${value ?? ""}`;
        }
      },
      {
        id:'createdAt',
        field: 'createdAt',
        text: t('formReports.grid.createdAt'),
        flex: 1,
        type: "template",
        template: ({value}:any) => {
          if(NullOrUndefinedHelper(value))return "";

          const date = new Date(`${value}Z`);
          const dateString = DateToStringHelper(date);
          return StringHelper.xss`${dateString}`;
        },
      },
      {
        id:'changedAt',
        field: 'changedAt',
        text: t('formReports.grid.changedAt'),
        flex: 1,
        type: "template",
        template: ({value}:any) => {
          if(NullOrUndefinedHelper(value))return "";

          const date = new Date(`${value}Z`);
          const dateString = DateToStringHelper(date);
          return StringHelper.xss`${dateString}`;
        },
      },
      {
        id:'finishedAt',
        field: 'finishedAt',
        text: t('formReports.grid.finishedAt'),
        flex: 1,
        type: "template",
        template: ({value}:any) => {
          if(NullOrUndefinedHelper(value))return "";

          const date = new Date(`${value}Z`);
          const dateString = DateToStringHelper(date);
          return StringHelper.xss`${dateString}`;
        },
      },
      {
        id:'exportPdf',
        field:'exportPdf',
        text: '',
        width   : 36,
        hideable: false,
        resizable: false,
        sortable: false,
        filterable: false,
        tooltipRenderer : () => StringHelper.xss`${t('formReports.grid.tooltips.exportPdf')}`,
        type: "template",
        template: ({record}:any) => {
          const isLoading = pdfLoadingRecords[record.id];
          if (!record.isOpen) {
            if (isLoading) {
              return `<div class='gridRowButton disabled'><div class="lds-ring lds-ring-small"><div></div><div></div><div></div><div></div></div></div>`;
            }
            return `<div class='gridRowButton'><span class="icon-downlaod"></span></div>`;
          }
          return "";
        },
      },
      {
        id:'changeOwner',
        field:'changeOwner',
        text: '',
        width   : 36,
        hideable: false,
        resizable: false,
        sortable: false,
        filterable: false,
        tooltipRenderer : () => StringHelper.xss`${t('formReports.grid.tooltips.changeOwner')}`,
        type: "template",
        template: ({record}:any) => {
          return (record.data.type === FormType.BTB || record.data.type === FormType.VPB) && record.data.isOpen
              ? `<div class='gridRowButton'><span class="icon-status_bald_inaktiv"></span></div>`
              : "";
        },
      },
      {
        id:'menu',
        text	: '',
        width   : 36,
        type	: 'widget',
        align: "center",
        hideable: false,
        resizable: false,
        sortable: false,
        filterable: false,
        widgets : [{
          type	 : 'button',
          width: 36,
          icon	 : 'icon-kontext_horizontal',
          onAction : ({ source: btn }:any) => {
            const menu = menuFactory(btn.cellInfo.record.data);
            menu.alignTo({ target: btn })
            menu.show();
          }
        }]
      },
    ],
    listeners:{
      async add(event:any){
        if(event.records.length === 1 && event.isMove[event.records[0].id]){
          await systemStore.saveUserColumnOrder(TableType[TableType.form], event.records[0].id, event.index.toString());
        }
      },
    }
  },
  store: gridStore,
  listeners: {
    selectionChange(event:any) {
      if(event.selection.length > 0 && event.selection[0]?.data === undefined) return;
      selectedForms.value = selectedForms.value.concat(event.selected.map(f=> f.data))
      selectedForms.value = selectedForms.value.filter(f => !event.deselected.map(fd => fd.data).some(fd => fd?.id === f?.id));
    },
    datachange(){
      systemStore.currentItems = gridStore.count;
      systemStore.allItems = gridStore.getCount({all:true});
    },
    async cellClick({column, record}:any) {
      if(column.data.field === 'changeOwner' && (record.data.type === FormType.BTB || record.data.type === FormType.VPB)){
        lastOwnerId = record.data.ownerId;
        systemStore.openPopup({
          data: record.data,
          action:changeOwnerForForm,
          resetButton:false,
          title:t("formReports.popups.owner.title"),
          type:PopupType.formReportChangeOwnerPopup
        });
      }
      if(column.data.field === 'exportPdf'){
        if(record.isOpen)return
        await exportPdf(record);
      }
    },
  },
  height: currentWindowHeight,
}
const gridConfig = reactive(useGridConfig)

const menuFactory = (record:any) => {
  const menu = new Menu({
    anchor   : true,
    autoShow : true,
    items	: [
      {
        text: t('formReports.menu.pdf'),
        cls: 'color',
        icon: 'icon-pdf',
        disabled: record.isOpen,
        weight: 100,
        onItem : async ({menu}:any) => {
          if(menu.record.isOpen)return
          await exportPdf(record);
        }
      },
      {
        text: t('formReports.menu.owner'),
        cls: 'color',
        icon: 'icon-anmelden',
        disabled: record.type !== FormType.BTB && record.type !== FormType.VPB,
        weight: 100,
        onItem : ({menu}:any) => {
          lastOwnerId = record.ownerId;
          systemStore.openPopup({
            data:menu.record,
            action:changeOwnerForForm,
            resetButton:false,
            title:t("popups.formReports.owner.title"),
            type:PopupType.formReportChangeOwnerPopup
          });
        }
      },
    ],
  });

  menu.setRecord(record);

  return menu;
};



const setGridData = async () => {
  // start spinner
  systemStore.gridDataIsLoading = true;

  const formReports = await formService.getFormReports(ErrorLocationType.table);
  if (!formReports) return;

  gridStore.setStoreData(formReports);

  // apply filters
  await gridStore.filter({
    id: "userFilter",
    filterBy: FilterService.buildFilter(TableType[TableType.form])
  });

  // apply hidden cols
  for(const c of grid.value.instance.value.columns.storage.values){
    const needsHiding = systemStore.userPreferences.userHiddenColumns
        .some((thc) => thc.attributeName === c.data.field && thc.tableName === TableType[TableType.form]);

    if(needsHiding && !c.hidden) {
      c.hide();
    }
    else if(!needsHiding && c.hidden && !featureColumn.includes(c.id)) {
      c.show();
    }
  }

  systemStore.reorderColumns(TableType[TableType.form]);

  // stop spinner
  systemStore.gridDataIsLoading = false;
}

const changeOwnerForForm = async ()=>{
  const form = systemStore.modal.contentObject as Form;
  // check if owner even changed before calling change API
  if(lastOwnerId === form.ownerId) return

  const resp = await formService.changeCurrentOwnerOfForm(form.id, form.ownerId, ErrorLocationType.popup);
  console.log("change owner resp", resp); //TODO type and remove
  if(!resp) return;

  gridStore.add(form)
  // reapply sorting
  await gridStore.sort(gridStore.sorters);
  // reapply filtering
  await gridStore.filter({
    id: "userFilter",
    filterBy: FilterService.buildFilter(TableType[TableType.form])
  });

  lastOwnerId = ""
  systemStore.closeModal();
  systemStore.showSuccess(t('global.saved'));
};

const exportPdf = async (form:Form) => {
  if(pdfExportRunning.value) return;
  pdfExportRunning.value = true;
  pdfLoadingRecords[form.id] = true;
  
  // Finde den Record im Store und aktualisiere die Anzeige
  const record = gridStore.getById(form.id);
  if(record) {
    grid.value.instance.value.renderContents();
  }

  try {
    let pdfData: any = await formService.ensurePdfCreationThenFetch(form.id, ErrorLocationType.table);

    if(!pdfData) {
      pdfData = await formService.generatePdf(form.id, ErrorLocationType.table);
      if(!pdfData) {
        pdfExportRunning.value = false;
        delete pdfLoadingRecords[form.id];
        if(record) {
          grid.value.instance.value.renderContents();
        }
        return;
      }
    }

    const blob = new Blob([pdfData], {type: "application/pdf"});
    const link = document.createElement("a");
    
    link.href = window.URL.createObjectURL(blob);
    link.download = `${form.createdAt.split('T')[0]}_${form.id}.pdf`;
    link.click();
    link.remove();

    systemStore.showSuccess(t("formReports.startingPdfDownload"));
  } finally {
    pdfExportRunning.value = false;
    delete pdfLoadingRecords[form.id];
    if(record) {
      grid.value.instance.value.renderContents();
    }
  }
}

onMounted(async ()=>{
  // calculate grid height and sub to window resize event
  recalcGridHeight();
  window.addEventListener('resize', recalcGridHeight);

  systemStore.setGridStore(ref(gridStore));
  systemStore.setGridColumnStore(ref(grid.value?.instance.value?.columns));

  // start spinner
  systemStore.gridDataIsLoading = true;
  await setGridData();
  // stop spinner
  systemStore.gridDataIsLoading = false;
})

onBeforeUnmount(async ()=>{
  window.removeEventListener('resize', recalcGridHeight);

  systemStore.setGridStore(null);
  systemStore.setGridColumnStore(null);

  systemStore.currentItems = 0;
  systemStore.allItems = 0;
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h4", null, _toDisplayString(_ctx.$t("formReports.title")), 1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("div", null, [
        _createVNode(Error, {
          errorLoc: _unref(ErrorLocationType).table
        }, null, 8, ["errorLoc"]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(GridInputFilter, {
                gridStore: _unref(gridStore),
                hideFilterButton: true
              }, null, 8, ["gridStore"])
            ])
          ]),
          _createVNode(_unref(BryntumGrid), _mergeProps({
            ref_key: "grid",
            ref: grid
          }, gridConfig, { readOnly: true }), null, 16)
        ])
      ], 512), [
        [_vShow, !_unref(systemStore).gridDataIsLoading]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_6, [
        _createVNode(LoadingSpinner)
      ], 512), [
        [_vShow, _unref(systemStore).gridDataIsLoading]
      ])
    ])
  ], 64))
}
}

})